<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { fetchSucursales, saveSucursal, removeSucursal, searchSucursales, subscribeToSucursales, unsubscribeFromSucursales } from '../controllers/sucursalController.js';
    import { fetchEmpresas } from '../controllers/empresaController.js'; // Función para cargar las empresas

    let sucursalColumns = [
        { label: 'Empresa', field: 'empresa_descrip', type: 'text' },
        { label: 'Descripción', field: 'descrip', type: 'text' },
        { label: 'Dirección', field: 'direccion', type: 'text' },
        { label: 'Departamento', field: 'departamento', type: 'text' },
        { label: 'Municipio', field: 'municipio', type: 'text' },
        { label: 'Teléfono', field: 'telefono', type: 'text' },
        { label: 'Estado', field: 'sta', type: 'bool' },
    ];

    let newSucursal = {
        empresa: '',
        descrip: '',
        direccion: '',
        departamento: '',
        municipio: '',
        telefono: '',
        sta: true,
    };

    let editColumns = [
        { label: 'Empresa', key: 'empresa', type: 'select', required: true, fetchOptions: { key: 'id', value: 'nombre_comercial' }, options: [] },
        { label: 'Descripción', key: 'descrip', type: 'text', required: true },
        { label: 'Dirección', key: 'direccion', type: 'text', required: true },
        { label: 'Departamento', key: 'departamento', type: 'text', required: true },
        { label: 'Municipio', key: 'municipio', type: 'text', required: true },
        { label: 'Teléfono', key: 'telefono', type: 'text', required: true },
        { label: 'Estado', key: 'sta', type: 'checkbox' }
    ];

    let empresaOptions = [];

    // Función para cargar y transformar empresas
    async function loadEmpresas() {
        try {
            const fetchedEmpresas = await fetchEmpresas();

            if (Array.isArray(fetchedEmpresas.empresa)) {
                empresaOptions = fetchedEmpresas.empresa.map(e => ({
                    key: e[editColumns.find(col => col.key === 'empresa').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'empresa').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'empresa').options = empresaOptions;
            } else {
                console.error('Se esperaba un array de empresas, pero se obtuvo:', fetchedEmpresas);
            }
        } catch (error) {
            console.error('Error al cargar las empresas:', error);
        }
    }

    // Cargar las empresas al montar el componente
    onMount(() => {
        loadEmpresas();
    });
</script>

<CRUD 
    title="Sucursales"
    entityName="sucursal"
    newEntity={newSucursal}
    columns={sucursalColumns}
    fetchEntities={fetchSucursales}
    saveEntity={saveSucursal}
    removeEntity={removeSucursal}
    searchEntities={searchSucursales}
    subscribeToChanges={subscribeToSucursales}
    unsubscribeFromChanges={unsubscribeFromSucursales}
    editColumns={editColumns}
/>
